export default {
  getCurrentPageContent: (state) => {
    const currentRoute = state.route.name === 'page' ? state.route.params.year : undefined;
    const indexPage = state.route.name === 'page' ? state.content.findIndex(el => el.idPage === currentRoute) : state.currentIndex;

    return indexPage === undefined ? state.content[0].content : state.content[indexPage].content;
  },
};
